import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from 'layouts/auth/auth.layout';
import BasicLayout from 'layouts/basic/basic.layout';
import SignUp from './auth/sign-up.page';
import SignIn from './auth/sign-in.page';
import Profile from './profile/profile.page';
import Dashboard from './dashboard/dashboard.page';
import Monitoring from './monitoring/monitoring.page';
import Policy from './policy/policy.page';
import InventoryReportPage from "./report/inventory-report.page";

export default function RoutesIndex() {
  return (
    <Routes>
      <Route path="" element={<AuthLayout />}>
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
      </Route>
      <Route path="/policy/:type" element={<Policy />} />
      <Route path="/" element={<BasicLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/monitoring" element={<Monitoring />} />
        {/* Old path kept so existing links and bookmarks keep working */}
        <Route path="/history" element={<Navigate to="/monitoring" replace />} />
        <Route path="/report" element={<InventoryReportPage />} />
      </Route>
    </Routes>
  );
}
